<template>
	<div class="crumbs">
		<div @click="toback" class="crumbs_return">
			<i class="el-icon-arrow-left"></i>
			<span>返回</span>
			<span class="crumbs_return_br"></span>
		</div>
		<div class="crumbs_item" @click="toCrumb(item)" v-for="(item,index) in crumbList" :key="index">
			<div :style="{color:index<(crumbList.length-1)?'#6a6a6a':'#000'}" class="crumbs_item_name">{{item.name}}</div>
			<div v-if="index<(crumbList.length-1)" class="crumbs_item_br">/</div>
		</div>
	</div>
</template>

<script>
	import {
		resolveCrumbs
	} from "./crumbsUtils.js";

	export default {
		name: "",
		props: {
			list: {
				type: [Array, String, Object],
				default: () => []
			}
		},
		data() {
			return {};
		},
		computed: {
			crumbList() {
				const routeText = this.$store.getters.menuTree || [];
				const list = resolveCrumbs(this.list, routeText, this.$route.path);
				if (list.length > 0) return list;
				if (this.$route.meta && this.$route.meta.title) {
					return [{
						name: this.$route.meta.title,
						path: '',
						query: ''
					}];
				}
				return [];
			}
		},
		methods: {
			toback() {
				this.$router.go(-1);
			},
			toCrumb(item) {
				if (!item.path) return;
				this.$router.push({
					path: item.path,
					query: item.query && typeof item.query === 'object' ? item.query : {}
				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.crumbs{
		display: flex;
		height: 40px;
		line-height: 40px;
		align-items: center;
		&_return{
			padding: 0 20px 0 10px;
			align-items: center;
			justify-content: center;
			display: flex;
			cursor: pointer;
			position: relative;
			margin-right: 20px;
			i{
				color: #6a6a6a;
				margin-right: 4px;
				font-weight: bold;
				font-size: 14px;
			}
			span{
				color: #6a6a6a;
				font-size: 14px;
			}
			&_br{
				position: absolute;
				right: 0;
				width: 1px;
				height: 18px;
				background-color: #6a6a6a;
			}
		}
		&_item{
			display: flex;
			cursor: pointer;
			&_name{
				font-size: 14px;
			}
			&_br{
				font-size: 14px;
				color: #6a6a6a;
				padding: 0 10px;
			}
		}
	}
</style>
